import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Porteur } from '../../../../shared/porteur';
import { ArticleGenerique } from '../../../../../../delivery/shared/article-generique/article-generique';

@Component({
  selector: 'app-val-ret-article',
  templateUrl: './val-ret-article.component.html',
  styleUrls: ['./val-ret-article.component.scss']
})
export class ValRetArticleComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ValRetArticleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {porteur: Porteur, article: ArticleGenerique}) { 
  }

  ngOnInit() {
  }

  valid(){
    this.dialogRef.close(true);
  }

  refuse(){
    this.dialogRef.close(false);
  }

}
